function Progress() {
  return <div className="progress"></div>;
}

export default Progress;
